// Shared react-toastify options for the app's `prettyToast` style (the class is
// styled in index.css). Every surface uses the same placement and interaction
// behavior; only the dismiss delay varies by page, so that's the one field
// worth overriding.
export const PRETTY_TOAST_OPTS = {
  className: 'prettyToast',
  position: 'top-center',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  theme: 'light',
};

// `prettyToastOpts({ autoClose: 7000 })` for a page that wants a different
// dismiss delay. Returns a fresh object so callers can't mutate the shared one.
export function prettyToastOpts(overrides = {}) {
  return { ...PRETTY_TOAST_OPTS, ...overrides };
}
